import React from 'react';
import { Typography } from 'antd';

import {
  DeviceKey,
  SyncConflict,
} from '@totem/components/administration/deviceSyncMerges/types';

const { Text } = Typography;

export const DeviceKeyList = ({ keys }: { keys: DeviceKey[] | null }) => (
  <>
    {(keys ?? []).map((key) => (
      <div key={`${key.type}:${key.apiConnectionId}:${key.value}`}>
        <Text type="secondary">{key.type}:</Text> {key.value}
      </div>
    ))}
  </>
);

// The tool record that matched the portal devices. Conflicts recorded before the tool record was captured only have
// the keys that matched, until the next sync refreshes them.
const DeviceSyncSource = ({ conflict }: { conflict: SyncConflict }) => {
  const source = conflict.source;
  const keys = source?.keys?.length ? source.keys : conflict.matchedKeys;

  return (
    <>
      {source?.tool && <Text strong>{source.tool}</Text>}
      {(source?.assetName || source?.assetId) && (
        <div>
          {source.assetName || '(no name)'}
          {source.assetId && <Text type="secondary"> ({source.assetId})</Text>}
        </div>
      )}
      <DeviceKeyList keys={keys} />
    </>
  );
};

export default DeviceSyncSource;
